// Global time function that can be overridden for testing
let globalTimeFunction: (() => number) | null = null

export function setGlobalTimeFunction(timeFn: () => number): void {
    globalTimeFunction = timeFn
}

export function getCurrentTime(): number {
    return globalTimeFunction ? globalTimeFunction() : Date.now()
}
